import React, { createContext, useContext, useState, useCallback } from "react";
import { ReportErrorModal } from "../components/ReportErrorModal";

interface ReportErrorContextType {
  openReportModal: (errorMessage?: string, errorStack?: string) => void;
}

const ReportErrorContext = createContext<ReportErrorContextType | null>(null);

export const ReportErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [errorStack, setErrorStack] = useState<string | undefined>();

  const openReportModal = useCallback(
    (msg?: string, stack?: string) => {
      setErrorMessage(msg);
      setErrorStack(stack);
      setIsOpen(true);
    },
    []
  );

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setErrorMessage(undefined);
    setErrorStack(undefined);
  }, []);

  return (
    <ReportErrorContext.Provider value={{ openReportModal }}>
      {children}
      <ReportErrorModal
        isOpen={isOpen}
        onClose={handleClose}
        errorMessage={errorMessage}
        errorStack={errorStack}
      />
    </ReportErrorContext.Provider>
  );
};

export const useReportError = () => {
  const ctx = useContext(ReportErrorContext);
  return ctx?.openReportModal ?? (() => {});
};
